import React from "react";
import ShipmentHistoryListItem from "../../components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const ShipmentHistoryListPage = ()  => {

    useTitle(t`List Shipment History`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <ShipmentHistoryListItem showAdd={true} {...query} />
        </Box>
    )
}

export default ShipmentHistoryListPage;
